module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationSingaporeThumb.8d615c31.jpg";